import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/6a8340febedae70014662392_1787044913021_f1f274b2/safaruna/src/app/sign-up-login-screen/components/LoginPageClient.tsx");
